module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/logo_visa.5f04499f.svg";